module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper-setting"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "bg-white min-height"
  }, [_c('home-sidebar', {
    attrs: {
      "active_item": "password"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "bg-white min-height ml-3"
  }, [_c('div', {
    staticClass: "pt-3"
  }, [_c('el-form', {
    ref: "changeForm",
    staticStyle: {
      "padding-right": "50px"
    },
    attrs: {
      "model": _vm.changeForm,
      "status-icon": "",
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "原密码",
      "prop": "oldPwd"
    }
  }, [_c('el-input', {
    staticClass: "item_w",
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.changeForm.oldPwd),
      callback: function($$v) {
        _vm.$set(_vm.changeForm, "oldPwd", $$v)
      },
      expression: "changeForm.oldPwd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "新密码",
      "prop": "painpwd"
    }
  }, [_c('el-input', {
    staticClass: "item_w",
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.changeForm.painpwd),
      callback: function($$v) {
        _vm.$set(_vm.changeForm, "painpwd", $$v)
      },
      expression: "changeForm.painpwd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认新密码",
      "prop": "newPwd"
    }
  }, [_c('el-input', {
    staticClass: "item_w",
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.changeForm.newPwd),
      callback: function($$v) {
        _vm.$set(_vm.changeForm, "newPwd", $$v)
      },
      expression: "changeForm.newPwd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clk_update_pass.apply(null, arguments)
      }
    }
  }, [_vm._v("确定修改")])], 1)], 1)], 1)])])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0633299a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/users/Password.vue
// module id = 262
// module chunks = 1